import React from "react";
import styled from "styled-components";
import { sm, xmd, md } from "@origyn-sa/common-ui/src/AppTheme.styled";

const ExploreStyled = styled.div`
  .topGrid {
    grid-column-start: 1;
    grid-column-end: 6;
  }

  .gridSearchInput {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  .displayButtonFilter {
    display: inline-block;
    grid-column-start: 4;
    grid-column-end: 5;
  }

  .displayFilter {
    display: none;
  }

  ${sm} {
    .topGrid {
      grid-column-start: 1;
      grid-column-end: 6;
    }
    .gridSearchInput {
      grid-column-start: 1;
      grid-column-end: 3;
    }

    .displayButtonFilter {
      display: inline-block;
      grid-column-start: 4;
      grid-column-end: 5;
    }

    .displayFilter {
      display: none;
    }
  }

  ${md} {
    .topGrid {
      grid-column-start: 1;
      grid-column-end: 6;
    }

    .gridSearchInput {
      grid-column-start: 1;
      grid-column-end: 3;
    }

    .displayButtonFilter {
      display: inline-block;
      grid-column-start: 4;
      grid-column-end: 5;
    }

    .displayFilter {
      display: none;
    }
  }

  ${xmd} {
    .topGrid {
      grid-column-start: 1;
      grid-column-end: 5;
    }

    .gridSearchInput {
      grid-column-start: 1;
      grid-column-end: 4;
    }

    .displayButtonFilter {
      display: none;
    }

    .displayFilter {
      display: block;
    }
  }
`;
export default ExploreStyled;
